import map from "lodash/map";
import ChapterSlideshowContainer from "containers/ChapterSlideshowContainer";
import getShowChapterNavigationAsSlideshow from "selectors/breakpoint/getShowChapterNavigationAsSlideshow";
import NavigationWrapper from "utils/NavigationWrapper";
import PropTypes from "prop-types";
import React from "react";
import { AnalyticsActions } from "utils/Analytics";
import { compose, onlyUpdateForPropTypes, withHandlers } from "recompose";
import { connect } from "react-redux";
import ChapterList from "./ChapterList";

function ChapterListing(props) {
  if (props.showChapterNavigationAsSlideshow) {
    return <ChapterSlideshowContainer {...props} />;
  }
  return <ChapterList {...props} />;
}

ChapterListing.propTypes = {
  chapters: PropTypes.array.isRequired,
  isShowingStoryCover: PropTypes.bool.isRequired,
  onChapterClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  showChapterNavigationAsSlideshow: PropTypes.bool.isRequired,
  storySlug: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  chapters: map(state.story.chapters, "id"),
  isShowingStoryCover: !state.route.params.chapterSlug,
  onChapterClick(routeData) {
    ownProps.onClose({ isPassive: true, transitioning: true }); // transitioning is true

    AnalyticsActions.storyInfoChapterClick({
      chapterId: routeData.chapterId,
      chapterTitle: routeData.chapterTitle,
    });

    NavigationWrapper.push(
      null,
      state.route.params.storySlug,
      routeData.chapterKey,
      routeData.subchapterKey,
      {
        destroyPlaybackStateForChapterId: routeData.chapterId,
      },
    );
  },
  showChapterNavigationAsSlideshow: getShowChapterNavigationAsSlideshow(
    state,
    ownProps,
  ),
  storySlug: state.route.params.storySlug,
});

const connector = connect(mapStateToProps);

export default compose(
  connector,
  withHandlers({
    onChapterClick: (props) => props.onChapterClick,
  }),
  onlyUpdateForPropTypes,
)(ChapterListing);
